import { BrowserRouter, useRoutes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "./src/ProtectedRoute";
import OneDeskLayout from "./src/OneDeskLayout";
import OneDeskDashboard from "./src/OneDeskDashboard";
import HotelList from "./src/HotelList";
import NewHotel from "./src/NewHotel";
import AdminUsers from "./src/AdminUsers";
import Performance from "./src/Performance";
import Settings from "./src/Settings";
import ResetPassword from "./src/ResetPassword";
import OneDeskLogin from "./src/OneDeskLogin";
import ChannelManager from "./src/ChannelManager";
import Subscription from "./src/Subscription";
import PublicNewHotel from "./src/PublicNewHotel";
import type { RouteObject } from "react-router-dom";

const routes: RouteObject[] = [
  {
    path: "/desklogin",
    element: <OneDeskLogin />,
  },
  {
    path: "/register-hotel",
    element: <PublicNewHotel />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <OneDeskLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "dashboard", element: <OneDeskDashboard /> },
      { path: "hotels", element: <HotelList /> },
      { path: "hotels/new", element: <NewHotel /> },
      { path: "admins", element: <AdminUsers /> },
      { path: "performance", element: <Performance /> },
      { path: "settings", element: <Settings /> },
      { path: "reset-password", element: <ResetPassword /> },
      { path: "channel-manager", element: <ChannelManager /> },
      { path: "subscription", element: <Subscription /> },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/dashboard" replace />,
  },
];

const AppRoutes = () => {
  const element = useRoutes(routes);
  return element;
};

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <Toaster
        position="top-center"
        gutter={12}
        toastOptions={{
          duration: 3000,
          style: {
            borderRadius: "8px",
            padding: "12px 16px",
            color: "#fff",
            fontSize: "15px",
            fontWeight: 500,
          },
          success: {
            style: { background: "#22c55e" },
            iconTheme: { primary: "#22c55e", secondary: "#fff" },
          },
          error: {
            style: { background: "#ef4444" },
            iconTheme: { primary: "#ef4444", secondary: "#fff" },
          },
          loading: {
            style: { background: "#2563eb" },
          },
          custom: {
            style: { background: "#eab308" },
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
